import Slider from "../components/sliderProject";
import NewsPanel from "../components/newsPanel";
import React from 'react';
import { Carousel } from 'antd';
import { Link as RouterLink } from "react-router-dom";

// Banner轮播数据（使用 PUBLIC_URL 确保在开发/生产环境下路径一致）
const bannerData = [
  {
    image: process.env.PUBLIC_URL + "/images/banner2.png",
    title: "First Galactic Center Black Hole",
  },
  {
    image: process.env.PUBLIC_URL + "/images/space_10.gif",
    title: "3D Photography of Satellites",
  },
  {
    image: process.env.PUBLIC_URL + "/images/br.png",
    title: "Quantitative Ultrasound Tomography",
  },
  {
    image: process.env.PUBLIC_URL + "/images/home1.png",
    title: "Microscopic Adaptive Optics",
  },
  {
    image: process.env.PUBLIC_URL + "/images/home3.gif",
    title: "Biomedical Inverse Scattering",
  }
];

const researchFocus = [
  {
    title: "AI & Computation",
    description: "We build computational methods that model scientific processes, solve inverse problems, generate reconstructions, and enable intelligent inference.",
    keywords: ["Computational Physics", "Inverse Problems", "Generative AI", "Edge AI & Computing"],
    image: process.env.PUBLIC_URL + "/rawdata/project_neural.png",
  },
  {
    title: "Instrumentation",
    description: "We design optical, acoustic, and computational imaging systems that acquire informative measurements in difficult scientific regimes.",
    keywords: ["Adaptive Optics", "Interferometry", "Computational Microscopy", "Ultrasound Tomography", "Depth Sensing"],
    image: process.env.PUBLIC_URL + "/rawdata/direction_ao.png",
  },
  {
    title: "Science",
    description: "We apply intelligent imaging to scientific questions spanning the universe, engineered materials, and living systems.",
    keywords: ["Black Holes", "Exoplanets", "Space Situational Awareness", "Semiconductor Metrology", "Deep Tissue", "Live Cells"],
    image: process.env.PUBLIC_URL + "/rawdata/application_blackhole.png",
  },
];

const Home = () => {
    return (
        <div>
            {/* Banner轮播区域 - 基于home1图片比例缩放，与news栏宽度一致 */}
            <div className="w-4/5 mx-auto">
              <Carousel autoplay autoplaySpeed={3000} effect="fade" arrows={false} className="custom-banner-carousel">
                {bannerData.map((item, index) => (
                  <div key={index}>
                    {/* ✅ 每一页真正的 Banner 容器 */}
                    <div className="relative w-full aspect-[1970/1000] overflow-hidden">
                      {/* 1️⃣ 模糊背景层（始终铺满） */}
                      <img
                        src={item.image}
                        alt=""
                        className="absolute inset-0 w-full h-full object-cover blur-xl scale-110"
                      />

                      {/* 2️⃣ 半透明遮罩 */}
                      <div className="absolute inset-0 bg-black bg-opacity-30 z-10" />

                      {/* 3️⃣ 前景图：保持比例，自动填充至宽或高与容器一致 */}
                      <div className="absolute inset-0 z-20 flex items-center justify-center">
                        <img
                          src={item.image}
                          alt={`Banner ${index + 1}`}
                          className="w-full h-full object-contain"
                        />
                      </div>

                      {/* 4️⃣ 文本层 */}
                      <div className="absolute inset-0 z-30 flex items-center justify-center px-4">
                        <h1 className="text-white text-lg md:text-3xl lg:text-4xl font-bold drop-shadow-lg text-center">
                          {item.title}
                        </h1>
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>

            {/* 实验室介绍段落：插入在轮播与 Project Highlights 之间 */}
            <div className="w-4/5 mx-auto mt-12 mb-12 text-justify text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-800 px-4">
              <p className="mb-6 font-sans font-medium italic" style={{ fontFamily: 'Arial, sans-serif' }}>
              Imaging forms a fundamental interface between AI and the physical world. We advance this interface through AI-native instruments and computation, enabling machines to sense, reconstruct, simulate, and interact with physical world. We ultimately aim to push the frontiers of scientific imaging and discovery across extreme scales.<br />
              The lab is led by He Sun, Assistant Professor of Biomedical Engineering & Physics at Peking University.
              </p>
            </div>

            {/* Research Focus overview */}
            <section className="w-4/5 mx-auto mb-8">
              <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-2 mb-3">
                <div>
                  <h2 className="mt-0 mb-1 text-base md:text-lg">Research Focus</h2>
                  <p className="max-w-3xl text-xs md:text-sm text-gray-600">
                    We combine optics, physics, and machine learning to recover hidden structures and dynamics from scientific measurements.
                  </p>
                </div>
                <RouterLink to="/direction" className="text-xs md:text-sm text-blue-600 hover:text-blue-800 whitespace-nowrap">
                  Explore our research →
                </RouterLink>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {researchFocus.map((focus) => (
                  <article key={focus.title} className="flex items-start gap-3 rounded-md border border-gray-200 bg-white p-3 transition-shadow hover:shadow-md">
                    <div className="h-16 w-16 flex-none overflow-hidden rounded bg-gray-100 md:h-20 md:w-20">
                      <img src={focus.image} alt={focus.title} className="w-full h-full object-contain" />
                    </div>
                    <div className="min-w-0">
                      <h3 className="mb-1 text-sm md:text-base font-semibold text-gray-800">{focus.title}</h3>
                      <p className="mb-2 text-[11px] md:text-xs leading-snug text-gray-600">{focus.description}</p>
                      <div className="flex flex-wrap gap-1">
                        {focus.keywords.map((keyword) => (
                          <span key={keyword} className="rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] text-gray-600">
                            {keyword}
                          </span>
                        ))}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </section>

            <div className="w-4/5 mx-auto">
                <h2 className="mt-10 text-lg md:text-2xl">Project Highlights</h2>
                <Slider />
            </div>

            <div className="w-4/5 mx-auto mt-8 mb-20">
                <h2 className="mt-10 text-lg md:text-2xl">News</h2>
                <NewsPanel />
            </div>
        </div>
    );
};

export default Home;
